module.exports = __webpack_public_path__ + "img/dach.1840cf3b.webp";